import {useState, useCallback} from 'react';
import updatePoint from './dispatchers/updatePoint';
import createPoint from './dispatchers/createPoint';
import removePoint from './dispatchers/removePoint';
import create from './dispatchers/create';
import remove from './dispatchers/remove';
import update from './dispatchers/update';
import takeLocal from './dispatchers/takeLocal';
import useIsSaved from '../useIsSaved';

export type TrackDispatcher = (action: TrackAction) => string;

export default function useTracks(
    project: MapProject,
    highlight: MapHighlight,
): [{[trackLocalId: string]: Track}, TrackDispatcher, boolean] {

    const [tracks, setTracks] = useState<{[trackLocalId: string]: Track}>({});
    const [isSaved, addSavePromise] = useIsSaved();

    const dispatcher = useCallback((action: TrackAction): string => {
        if (action.type === 'updatePoint') {
            return updatePoint({action, tracks, setTracks, project, addSavePromise});
        } else if (action.type === 'createPoint') {
            return createPoint(action, tracks, setTracks);
        } else if (action.type === 'removePoint') {
            return removePoint(action, tracks, setTracks, project, addSavePromise);
        } else if (action.type === 'create') {
            return create(action, tracks, setTracks, project, addSavePromise);
        } else if (action.type === 'remove') {
            return remove(action, tracks, setTracks, addSavePromise);
        } else if (action.type === 'update') {
            return update(action, tracks, setTracks, project, addSavePromise);
        } else if (action.type === 'takeLocal') {
            return takeLocal(action, tracks, setTracks, highlight);
        } else throw new Error('Unrecognized action type');
    }, [addSavePromise, highlight, project, tracks]);

    return [tracks, dispatcher, isSaved];
}
